const LocalStorageKeys = {
  Session: 'Session',
  Theme: 'Theme',
  ECID: 'ecid',
  APIHost: 'APIHost',
  Filter: 'Filter',
}

export default LocalStorageKeys
